import React, { Fragment } from 'react';

import {
    Paper,
    Box,
    Button,
    Typography,
    Icon,
    colors,
    Grid,
    makeStyles,
    Tooltip
} from '@material-ui/core';

import {BsPinAngleFill} from "react-icons/bs";
import { MdRouter } from "react-icons/md";
import { MdMultilineChart } from 'react-icons/md';

const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
        flexDirection: 'column'
    },
    statsItem: {
        alignItems: 'center',
        display: 'flex'
    },
    statsIcon: {
        marginRight: theme.spacing(1)
    },
    avatar: {
        width: 70,
        height: 70,
        marginRight: theme.spacing(2),
        backgroundColor: colors.grey[200]
    },
    cardIcon: {
        width: 50,
        height: 50
    },
    cardEquipment: {
        minWidth: 350,
        maxWidth: 350
    },
    chipgreenlarge: {
        backgroundColor: colors.blue[400],
        width: 90,
    }

}));

const EquipmentProfile = ({ activation, openAcitivity, openHistory }) => {

    const classes = useStyles();

    return (
        <Fragment>
            <Box margin={1}
                alignItems="center"
                display="flex"
                flexDirection="column"
                component={Paper}
                variant="outlined"
                padding={2}
            >
                <Typography align="center"
                    color="textPrimary"
                    gutterBottom
                    variant="h3"
                >
                    {activation.equipment.name}
                </Typography>

                <Typography align="center" gutterBottom color="secondary" variant="h4">
                    {activation.equipment.description}
                </Typography>

                <Grid
                    container
                    spacing={1}
                    direction="row"
                    justify="center"
                    alignItems="center">
                    <Grid
                        item>
                        <Tooltip title="Visualizar ponto de instalação">
                            <Button color="secondary"
                                startIcon={<Icon component={BsPinAngleFill} style={{ color: colors.blue[400] }} ></Icon>}
                                size="medium"
                                variant="outlined">Local: {activation.location.name}
                            </Button>
                        </Tooltip>

                    </Grid>
                    <Grid
                        item>

                        <Tooltip title="Visualizar dispositivo instalado">
                            <Button color="secondary"
                                startIcon={<Icon component={MdRouter} style={{ color: colors.blue[400] }} ></Icon>}
                                size="medium"
                                variant="outlined">Dispositivo: {activation.device}
                            </Button>
                        </Tooltip>

                    </Grid>
                    <Grid
                        item>

                        <Tooltip title="Visualizar Gráfico de Atividade">
                            <Button color="secondary"
                                startIcon={<Icon component={MdMultilineChart} style={{ color: colors.blue[400] }} ></Icon>}
                                size="medium"
                                variant="outlined"
                                onClick={() => { openAcitivity(activation.equipment) }}
                            >Gráficos
                            </Button>
                        </Tooltip>
                    </Grid>
                </Grid>

            </Box>


        </Fragment>
    );
};

export default EquipmentProfile;
